import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.hulkcabeleireiro.com.br',
    timeout: 5000,
});